import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgBlr = function SvgBlr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 30.886V1.114C8.812.394 12.436.032 16 0c3.75.033 7.567.432 9.69 1.263 4.447 1.728 5.477 6.646 5.477 6.646.663 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.564-.032-7.188-.394-9.334-1.114Z",
    fill: "#1AAF5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.66 21.333H6.666V1.113C8.813.394 12.436.033 16 0c3.75.033 7.567.432 9.69 1.263 4.447 1.728 5.477 6.646 5.477 6.646.663 2.758.863 5.582.83 8.107a34.85 34.85 0 0 1-.337 5.317Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v32h6.667V0H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 15.333 6.667 17.5v1.272l-1.334-2.167-1.883 3.062 1.883 3.061 1.334-2.167v1.272L5.333 24l-2-3.25-2 3.25-.666-2.167v-1.272l.666 2.167 1.884-3.061-1.884-3.062-1.212 2.167L.066 17.5l1.267-2.167 2 3.25 2-3.25Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.333 8 1.334 2.167v1.272L5.333 9.272 3.45 12.333l1.883 3.062 1.334-2.167V14.5l-1.334 2.167-2-3.25-2 3.25-1.226-1.971v-1.272l1.226 1.97 1.884-3.06-1.884-3.062-.666 2.167v-1.272L1.333 8l2 3.25 2-3.25Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.334 9.333v1.334L.667 12v-1.333l.667-1.334Zm4.666 0 .667 1.334L6 12l-.667-1.333L6 9.333ZM.667 20l.667 1.333v1.334l-.667-1.334V20ZM6 20l.667 1.333L6 22.667l-.667-1.334L6 20ZM2.445 5.333l.666 1.334L2.444 8l-.666-1.333.667-1.334Zm1.777 0 .667 1.334L4.222 8l-.666-1.333.666-1.334Zm1.778 0 .667 1.334L6 8l-.667-1.333L6 5.333ZM2.445 24l.666 1.333-.667 1.334-.666-1.334L2.445 24Zm1.777 0 .667 1.333-.667 1.334-.666-1.334L4.222 24ZM6 24l.667 1.333L6 26.667l-.667-1.334L6 24Z",
    fill: "#E94B35"
  }));
};

export default SvgBlr;